// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"284":"34dda6c7","701":"6b2fcf19","948":"a6520fd2"}[chunkId] + ".js";
};